import React from 'react';

const Card = (props) => {
	const { name, email } = props;
	return (
		<div className="bg-light-green dib br3 pa3 ma2 grow bw2 shadow-5">
			<img src={`https://robohash.org/${props.id}?200*200`} alt="photodsf" />
			<div>
				<h2>{name}</h2>
				<p> {email} </p>
			</div>
		</div>
	);
};

export default Card;
